import { useNavigate } from "react-router-dom";
import {
  CheckSquare, Users, Calculator, Search, BarChart2, BookOpen,
  Trophy, MapPin, BookMarked, ClipboardCheck, Newspaper, Sliders, Bot, UserCheck, Zap,
} from "lucide-react";

const TOOLS = [
  { icon: CheckSquare, label: "Party Match Quiz",      desc: "10 questions, find your party",       path: "/quiz",         color: "#0D5C3A", softBg: "rgba(13,92,58,0.10)" },
  { icon: Users,       label: "Compare Parties",       desc: "Side-by-side policy table + AI",      path: "/compare",      color: "#2563EB", softBg: "rgba(37,99,235,0.10)" },
  { icon: Calculator,  label: "Impact Calculator",     desc: "How policies affect your life",        path: "/impact",       color: "#E11D48", softBg: "rgba(225,29,72,0.10)" },
  { icon: Search,      label: "Fact Checker",          desc: "AI verifies political claims",         path: "/fact-check",   color: "#8B5CF6", softBg: "rgba(139,92,246,0.10)" },
  { icon: BarChart2,   label: "Poll Tracker",          desc: "Live national polling data",           path: "/polls",        color: "#D97706", softBg: "rgba(217,119,6,0.10)" },
  { icon: BookOpen,    label: "Issue Deep Dives",      desc: "Key issues clearly explained",         path: "/issues",       color: "#0D9488", softBg: "rgba(13,148,136,0.10)" },
  { icon: Trophy,      label: "Historical Results",    desc: "Past election outcomes",               path: "/history",      color: "#065F46", softBg: "rgba(6,95,70,0.10)" },
  { icon: MapPin,      label: "Electorate Results",    desc: "How your area voted in 2025",          path: "/electorate",   color: "#E11D48", softBg: "rgba(225,29,72,0.10)" },
  { icon: BookMarked,  label: "Political Glossary",    desc: "Know the jargon, A–Z",                path: "/glossary",     color: "#9333EA", softBg: "rgba(147,51,234,0.10)" },
  { icon: ClipboardCheck, label: "Policy Scorecard",  desc: "Track party promises vs. delivery",    path: "/scorecard",    color: "#0369A1", softBg: "rgba(3,105,161,0.10)" },
  { icon: Newspaper,   label: "News Feed",             desc: "AI-generated political briefs",        path: "/news",         color: "#BE185D", softBg: "rgba(190,24,93,0.10)" },
  { icon: Sliders,     label: "Voting Simulator",      desc: "See how preferences flow",             path: "/simulator",    color: "#047857", softBg: "rgba(4,120,87,0.10)" },
  { icon: Bot,         label: "AI Chat",               desc: "Ask anything about Aus politics",      path: "/chat",         color: "#6D28D9", softBg: "rgba(109,40,217,0.10)" },
  { icon: UserCheck,   label: "They Vote For You",     desc: "Track politician voting records",      path: "/politicians",  color: "#E11D48", softBg: "rgba(225,29,72,0.10)" },
];

export default function ToolsGrid() {
  const navigate = useNavigate();

  return (
    <section
      className="py-16 px-4"
      style={{ background: "linear-gradient(180deg, #080E1A 0%, #0D1628 100%)" }}
      data-testid="tools-section"
    >
      <div className="max-w-6xl mx-auto">
        <div className="mb-10 text-center">
          <div
            className="inline-flex items-center gap-2 px-4 py-1.5 mb-4 text-xs font-semibold tracking-widest uppercase rounded-full"
            style={{ background: "rgba(234,179,8,0.10)", border: "1px solid rgba(234,179,8,0.20)", color: "#FACC15" }}
          >
            <Zap style={{ width: 11, height: 11 }} />
            Voter Toolkit
          </div>
          <h2 className="text-3xl sm:text-4xl font-black text-white tracking-tight" style={{ fontFamily: "Outfit, sans-serif" }}>
            Everything You Need This Election Season
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {TOOLS.map((tool) => {
            const Icon = tool.icon;
            return (
              <button
                key={tool.path}
                data-testid={`tool-card-${tool.path.slice(1)}`}
                onClick={() => navigate(tool.path)}
                className="group text-left transition-all duration-200 hover:-translate-y-1"
                style={{
                  background: "rgba(30,41,59,0.6)",
                  border: "1px solid rgba(51,65,85,0.5)",
                  borderRadius: 16,
                  padding: "20px",
                  cursor: "pointer",
                  boxShadow: "none",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "rgba(30,41,59,0.9)";
                  e.currentTarget.style.borderColor = `${tool.color}33`;
                  e.currentTarget.style.boxShadow = `0 8px 24px rgba(0,0,0,0.3), 0 0 0 1px ${tool.color}22`;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "rgba(30,41,59,0.6)";
                  e.currentTarget.style.borderColor = "rgba(51,65,85,0.5)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div
                  className="w-11 h-11 flex items-center justify-center mb-4 rounded-xl transition-transform duration-200 group-hover:scale-105"
                  style={{ background: tool.softBg, border: `1px solid ${tool.color}22` }}
                >
                  <Icon style={{ width: 20, height: 20, color: tool.color }} />
                </div>
                <h3 className="font-bold text-sm mb-1 tracking-tight" style={{ fontFamily: "Outfit, sans-serif", color: "#F8FAFC" }}>{tool.label}</h3>
                <p className="text-xs" style={{ color: "#64748B" }}>{tool.desc}</p>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
